import { render, staticRenderFns } from "./security_shifts.vue?vue&type=template&id=b9b5711c&scoped=true&"
import script from "./security_shifts.vue?vue&type=script&lang=js&"
export * from "./security_shifts.vue?vue&type=script&lang=js&"
import style0 from "./security_shifts.vue?vue&type=style&index=0&id=b9b5711c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b5711c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VChip,VContainer,VDataTable,VFlex,VIcon,VLayout,VSpacer,VTextField})
